// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__28pML","addWidgetButton":"Header_addWidgetButton__3sW2p","dashboardTabs":"Header_dashboardTabs__xZhT4","active":"Header_active__1EhlV"};